/* Permitido adicionar novos valores apenas se estiverem presentes na tabela de taxonomia
https://docs.google.com/spreadsheets/d/1dTq-dLf_q3_FjXGWk3RTgmHDJxRvfXxTQoeRwxJykyg/edit#gid=1951505218
*/

export enum System {
  HOTMART_CLUB = 'hotmart_club',
  HOTMART_HUB = 'hotmart_hub',
  HOTMART_PLATAFORM = 'hotmart_plataform'
}

export enum Entity {
  ADMIN = 'admin',
  HOME = 'home',
  SEARCH = 'search',
  PROFILE = 'profile',
  PRODUCT_CONSUME = 'product_consume',
  COMMUNITY = 'community'
}

export enum Action {
  VIEW_MIGRATOR_PAGE = 'view_migrator_page',
  VIEW_TO_PROCEED_WITH_MIGRATION = 'view_to_proceed_with_migration',
  VIEW_TO_MIGRATE_COMMUNITIES = 'view_to_migrate_communities',
  VIEW_TO_CANCEL_MIGRATION = 'view_to_cancel_migration',
  TRY_TO_UPLOAD_A_COVER_IMAGE = 'try_to_upload_a_cover_image',
  CLICK_TO_DELETE_A_COVER_IMAGE = 'click_to_delete_a_cover_image',
  CLICK_TO_UPLOAD_A_COVER_IMAGE = 'click_to_upload_a_cover_image',
  TRY_TO_POST = 'try_to_post',
  TRY_TO_DELETE_A_COVER_IMAGE = 'try_to_delete_a_cover_image',
  TRY_TO_POST_A_COMMENT_REPLY = 'try_to_post_a_comment_reply',
  TRY_TO_REACT_TO_A_POST = 'try_to_react_to_a_post',
  CLICK_TO_CHANGE_THE_COVER_IMAGE = 'click_to_change_the_cover_image',
  CLICK_ON_THE_AI_POWERED_POST_SUGGESTION = 'click_on_the_ai_powered_post_suggestion',
  CLICK_TO_POST = 'click_to_post',
  VIEW_COMMUNITY_FEED = 'view_community_feed',
  CLICK_OPEN_PROFILE = 'click_open_profile',
  CLICK_OPEN_MESSAGE_BOX = 'click_open_message_box',
  CLICK_POST_DETAIL = 'click_post_detail',
  TRY_CREATE_REACT_POST = 'try_create_react_post',
  TRY_READ_ACTIVITIES = 'try_read_activities',
  TRY_LOAD_HIGHLIGHTS = 'try_load_highlights',
  CLICK_ACCESS_CLASS = 'click_access_class',
  CLICK_ACCESS_COMMUNITY = 'click_access_community',
  CLICK_TO_EDIT_POST = 'click_to_edit_post',
  TRY_TO_EDIT_POST = 'try_to_edit_post',
  TRY_GET_MENTION_RESULTS = 'try_get_mention_results',
  CLICK_CHOSEN_MENTION = 'click_chosen_mention',
  TRY_PUBLISH_CONTENT_MENTION = 'try_publish_content_mention',
  VIEW_MEDIA_LIGHTBOX = 'view_media_lightbox',
  CLICK_READ_COMMENTS = 'click_read_comments',
  CLICK_SUGGESTED_COMMENT_CHIP = 'click_suggested_comment_chip',
  TRY_SEND_COMMENT = 'try_send_comment',
  CLICK_TO_DELETE_AUDIO_FILE = 'click_to_delete_audio_file',
  CLICK_TO_SELECT_AUDIO_SPEED = 'click_to_select_audio_speed',
  CLICK_TO_PLAYING_THE_AUDIO = 'click_to_playing_the_audio',
  CLICK_TO_ADJUST_THE_VOLUME = 'click_to_adjust_the_volume'
}

export enum Platform {
  WEB = 'WEB'
}

export enum ClubVersion {
  OLD_CLUB_MIDNIGHT = 'OLD_CLUB_MIDNIGHT',
  OLD_CLUB_CLASSIC = 'OLD_CLUB_CLASSIC',
  MEMBERSHIP = 'MEMBERSHIP'
}

export enum UserRole {
  OWNER = 'OWNER',
  MODERATOR = 'MODERATOR',
  ADMIN = 'ADMIN',
  CONSUMER = 'CONSUMER',
  VIEWER = 'VIEWER'
}

export enum CommunityType {
  PUBLIC = 'PUBLIC',
  PAID = 'PAID',
  PRIVATE = 'PRIVATE',
  PREMIUM = 'PREMIUM'
}

export enum ConnectionStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE'
}

export enum TryResult {
  SUCCESSFUL = 'SUCCESSFUL',
  FAILURE = 'FAILURE'
}

export enum ComponentName {
  CHANGE_COVER_MODAL = 'CHANGE_COVER_MODAL',
  CHANGE_COVER_BUTTON_OLD = 'CHANGE_COVER_BUTTON_OLD',
  CHANGE_COVER_BUTTON_DROPDOWN = 'CHANGE_COVER_BUTTON_DROPDOWN',
  CHANGE_COVER_BUTTON_HOVER = 'CHANGE_COVER_BUTTON_HOVER',
  DELETE_COVER_BUTTON_DROPDOWN = 'DELETE_COVER_BUTTON_DROPDOWN',
  DELETE_COVER_MODAL = 'DELETE_COVER_MODAL',
  DELETE_COVER_BUTTON_HOVER = 'DELETE_COVER_BUTTON_HOVER',
  CREATE_POST_MODAL_SCHEDULED = 'CREATE_POST_MODAL_SCHEDULED',
  DROPZONE_UPLOADER = 'DROPZONE_UPLOADER',
  CREATE_POST_MODAL = 'CREATE_POST_MODAL',
  CLUB_PROFILE = 'CLUB_PROFILE',
  UPPER_RIGHT_MENU = 'UPPER_RIGHT_MENU',
  FLOAT_BUTTON = 'FLOAT_BUTTON',
  HEADER_BUTTON = 'HEADER_BUTTON',
  MEMBER_RANK = 'MEMBER_RANK',
  POST_FEED = 'POST_FEED',
  MENU_OWNER = 'MENU_OWNER',
  AI_SUGGESTION = 'AI_SUGGESTION',
  POST_LIST = 'POST_LIST',
  MAIN_COMPONENT_FEED = 'MAIN_COMPONENT_FEED',
  SIDEBAR_RELATED_POST = 'SIDEBAR_RELATED_POST',
  FEED_CARD_HEADER_DROPDOWN = 'FEED_CARD_HEADER_DROPDOWN',
  TRENDING_POSTS = 'TRENDING_POSTS',
  POST_PAGE = 'POST_PAGE',
  POST_COMMENT = 'POST_COMMENT',
  CLASS_COMMENT = 'CLASS_COMMENT',
  HIGHLIGHTS_SECTION = 'HIGHLIGHTS_SECTION',
  POST_FEED_COMMENT = 'POST_FEED_COMMENT',
  POST_CREATE = 'POST_CREATE',
  AI_FIRST_POST_BUTTON_WELCOME = 'AI_FIRST_POST_BUTTON_WELCOME',
  AI_FIRST_POST_BUTTON_INTERACTION_MEMBER = 'AI_FIRST_POST_BUTTON_INTERACTION_MEMBER',
  AI_FIRST_POST_BUTTON_RULES_POST = 'AI_FIRST_POST_BUTTON_RULES_POST',
  EDIT_POST_MODAL = 'EDIT_POST_MODAL',
  PLAY_ON_POST_CREATION = 'PLAY_ON_POST_CREATION',
  PLAY_ON_FEED = 'PLAY_ON_FEED',
  PLAY_ON_POST_DETAIL = 'PLAY_ON_POST_DETAIL'
}

export enum ComponentSource {
  MAIN_COMPONENT_FEED = 'MAIN_COMPONENT_FEED',
  DELETE_COVER_BUTTON_HOVER = 'DELETE_COVER_BUTTON_HOVER',
  DELETE_COVER_BUTTON_DROPDOWN = 'DELETE_COVER_BUTTON_DROPDOWN',
  HEADER_BUTTON = 'HEADER_BUTTON',
  CHANGE_COVER_BUTTON_DROPDOWN = 'CHANGE_COVER_BUTTON_DROPDOWN',
  POST_REACTION = 'POST_REACTION',
  CHANGE_COVER_BUTTON_HOVER = 'CHANGE_COVER_BUTTON_HOVER',
  POST_LIST = 'POST_LIST',
  COMMENT = 'COMMENT_LIST',
  AI_SUGGESTION = 'AI_SUGGESTION',
  FLOAT_BUTTON = 'FLOAT_BUTTON',
  COURSE_LIST = 'COURSE_LIST',
  CHANGE_COVER_BUTTON_OLD = 'CHANGE_COVER_BUTTON_OLD',
  COMMUNITY_LIST = 'COMMUNITY_LIST',
  LEAVE_IT_YOUR_WAY = 'LEAVE_IT_YOUR_WAY',
  HIGHLIGHTS_SECTION = 'HIGHLIGHTS_SECTION'
}

export enum ProfileType {
  MY_PROFILE = 'MY_PROFILE',
  SOMEONE_PROFILE = 'SOMEONE_PROFILE'
}

export enum ContentType {
  POST = 'POST',
  COMMENT = 'COMMENT',
  COURSE = 'COURSE',
  COMMUNITY = 'COMMUNITY'
}

export enum PushKind {
  NOT_PUSH_EVENT = 'NOT_PUSH_EVENT'
}

export enum FailureDescription {
  NOT_FAILURE_RESULT_EVENT = 'NOT_FAILURE_RESULT_EVENT',
  ERROR_WHILE_FETCHING_DATA = 'ERROR_WHILE_FETCHING_DATA',
  NO_MESSAGE = 'NO_MESSAGE'
}

export enum MentionType {
  USER = 'USER',
  CLASS = 'CLASS',
  PRODUCT = 'PRODUCT',
  MODULE = 'MODULE',
  COMMUNITY = 'COMMUNITY'
}

export enum DeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE'
}
